import { useEffect, useRef, useState } from "react";

// Smooth count-up / arc tween from 0 -> target with easeOutCubic
export function useTween(target, duration = 1100) {
  const [v, setV] = useState(0);
  const raf = useRef();
  useEffect(() => {
    let start;
    cancelAnimationFrame(raf.current);
    const from = 0;
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setV(from + (target - from) * eased);
      if (p < 1) raf.current = requestAnimationFrame(step);
    };
    raf.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf.current);
  }, [target, duration]);
  return v;
}
